"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVideoValidationError = void 0;

var _videoIntegration = require("./videoIntegration.constants");

/**
 * @param {string} value
 * @returns {boolean}
 */
var isValidUrl = function isValidUrl(value) {
  var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
  '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
  '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
  '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
  '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
  '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator

  return !value || pattern.test(value);
};
/**
 * @param {string} value
 * @param {string | undefined} videoType
 * @returns {string | undefined}
 */


var getVideoValidationError = function getVideoValidationError(value, videoType) {
  if (videoType && !value) {
    return "The recipient video field is required when recipient video type is in ".concat(videoType);
  }

  var isUrl = isValidUrl(value);

  if (!isUrl) {
    return 'The URL you have provided is not valid';
  }

  var link = document.createElement('a');
  link.href = value;
  var domain = link.host.toLowerCase().split('.').slice(-2).join('.');
  var rule = _videoIntegration.videoHostValidationRule[domain];

  if (!rule) {
    return 'You have entered an unsupported URL format or video platform';
  }

  var isValid = Array.isArray(rule) ? rule.some(function (ruleItem) {
    return value.indexOf(ruleItem) === 0;
  }) : value.indexOf(rule) === 0;

  if (!isValid) {
    return "Embed video from ".concat(domain, " should have next format: ").concat(rule);
  }

  return undefined;
};

exports.getVideoValidationError = getVideoValidationError;